import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import HolidayTable from '@centers/components/tables/holiday-table/holiday-table.vue';

@Component({
  name: 'bpc-holidays',
  components: {
    'bpc-holiday-table': HolidayTable,
  },
})
export default class Holidays extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
